import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M11.334 16a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0m9 0a4.333 4.333 0 1 1-8.667 0 4.333 4.333 0 0 1 8.667 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M16.994 12.817a3.3 3.3 0 0 0-.593-.127.333.333 0 0 1 .08-.662q.364.045.711.152a.333.333 0 0 1-.198.637m-2.155.057q.283-.105.585-.158a.333.333 0 0 0-.115-.656q-.36.062-.702.19a.333.333 0 1 0 .232.624m-.799.43a3.4 3.4 0 0 0-.455.4.333.333 0 1 1-.484-.46q.252-.265.547-.48a.333.333 0 0 1 .393.54m-1.236 1.747q.087-.291.224-.562a.333.333 0 1 0-.594-.303q-.165.325-.27.676a.333.333 0 1 0 .64.19m-.137.99q.003.28.053.554a.333.333 0 1 1-.656.118q-.06-.327-.063-.667v-.105a.333.333 0 1 1 .666.01v.089m.687 1.986a3.3 3.3 0 0 1-.324-.512.333.333 0 0 0-.593.303q.165.325.388.615a.333.333 0 0 0 .53-.406m.654.646q.245.182.517.317a.333.333 0 0 1-.296.598 4 4 0 0 1-.62-.38.333.333 0 0 1 .4-.535m2.07.67a.3.3 0 0 0-.078-.01q-.307 0-.604-.054a.333.333 0 0 0-.12.656Q15.633 20 16 20a.3.3 0 0 0 .094-.013q.045.01.094.009.367-.018.72-.1a.333.333 0 1 0-.15-.649 3.3 3.3 0 0 1-.601.083.3.3 0 0 0-.078.013m0 0a.334.334 0 0 0 .016.644.334.334 0 0 0-.015-.644m1.758-6.126q.254.168.473.379a.333.333 0 1 0 .462-.481 4 4 0 0 0-.568-.454.333.333 0 1 0-.367.556m1.3 1.647a3.3 3.3 0 0 0-.258-.548.333.333 0 1 1 .575-.338q.184.315.309.659a.333.333 0 0 1-.627.227m.194.968a3.4 3.4 0 0 1-.026.617.333.333 0 1 0 .66.09 4 4 0 0 0 .031-.74.333.333 0 0 0-.666.033m-.564 2.03q.17-.253.292-.531a.333.333 0 1 1 .61.266 4 4 0 0 1-.35.638.333.333 0 0 1-.552-.373m-.614.684q-.232.196-.496.348a.333.333 0 1 0 .331.578q.317-.18.596-.417a.333.333 0 0 0-.43-.51",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m16 16.873-1.11.794.416-1.27-.972-.794h1.25l.416-1.27.417 1.27h1.25l-.972.794.416 1.27z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M14.714 13.286a3 3 0 1 0 2.572 0 .333.333 0 1 0-.286.602 2.333 2.333 0 1 1-2 0 .333.333 0 1 0-.286-.602"
    }
  )
);
var SvgFlagPry = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagPry_default = SvgFlagPry;

export { FlagPry_default as default };
